const typography = {
  "heading": {
    "xl": {
      "font-family": "SangBleuOGSans",
      "font-weight": "400",
      "font-style": "normal",
      "font-size": "3rem",
      "line-height": "4.02rem",
      "letter-spacing": "0.0625rem"
    },
    "l": {
      "font-family": "SangBleuOGSans",
      "font-weight": "400",
      "font-style": "normal",
      "font-size": "2.5rem",
      "line-height": "3.75rem",
      "letter-spacing": "0.0625rem"
    },
    "m": {
      "font-family": "SangBleuOGSans",
      "font-weight": "400",
      "font-style": "normal",
      "font-size": "1.75rem",
      "line-height": "2.52rem",
      "letter-spacing": "0.0625rem"
    },
    "s": {
      "font-family": "SangBleuOGSans",
      "font-weight": "400",
      "font-style": "normal",
      "font-size": "1.3125rem",
      "line-height": "1.8375rem",
      "letter-spacing": "0.0625rem"
    },
    "xs": {
      "font-family": "SangBleuOGSans",
      "font-weight": "400",
      "font-style": "normal",
      "font-size": "1rem",
      "line-height": "1.44rem",
      "letter-spacing": "0.0625rem"
    },
    "xxs": {
      "font-family": "SangBleuOGSans",
      "font-weight": "400",
      "font-style": "normal",
      "font-size": "0.875rem",
      "line-height": "1.26rem",
      "letter-spacing": "0.0625rem"
    }
  },
  "body": {
    "xxxl": {
      "font-family": "SangBleuKingdom",
      "font-stretch": "normal",
      "font-weight": "400",
      "font-style": "normal",
      "font-size": "1.5rem",
      "line-height": "2.76rem",
      "letter-spacing": "0.03125rem"
    },
    "xxl": {
      "font-family": "SangBleuKingdom",
      "font-stretch": "normal",
      "font-weight": "400",
      "font-style": "normal",
      "font-size": "1.375rem",
      "line-height": "2.6125rem",
      "letter-spacing": "0.03125rem"
    },
    "xl": {
      "font-family": "SangBleuKingdom",
      "font-stretch": "normal",
      "font-weight": "400",
      "font-style": "normal",
      "font-size": "1.25rem",
      "line-height": "2.375rem",
      "letter-spacing": "0.03125rem"
    },
    "l": {
      "font-family": "SangBleuKingdom",
      "font-stretch": "normal",
      "font-weight": "400",
      "font-style": "normal",
      "font-size": "1.125rem",
      "line-height": "2.1375rem",
      "letter-spacing": "0.03125rem"
    },
    "m": {
      "font-family": "SangBleuKingdom",
      "font-stretch": "normal",
      "font-weight": "400",
      "font-style": "normal",
      "font-size": "1rem",
      "line-height": "1.9rem",
      "letter-spacing": "0.04375rem"
    },
    "s": {
      "font-family": "SangBleuKingdom",
      "font-stretch": "normal",
      "font-weight": "400",
      "font-style": "normal",
      "font-size": "0.9375rem",
      "line-height": "1.5rem",
      "letter-spacing": "0.03125rem"
    },
    "xs": {
      "font-family": "SangBleuKingdom",
      "font-stretch": "normal",
      "font-weight": "400",
      "font-style": "normal",
      "font-size": "0.8125rem",
      "line-height": "1.21875rem",
      "letter-spacing": "0.03125rem"
    },
    "xxs": {
      "font-family": "Inter",
      "font-size": "0.6875rem",
      "font-style": "normal",
      "font-weight": "700",
      "line-height": "1.14125rem",
      "letter-spacing": "0.0375rem"
    },
    "xxxs": {
      "font-family": "Inter",
      "font-size": "0.5625rem",
      "font-style": "normal",
      "font-weight": "700",
      "line-height": "1.15313rem",
      "letter-spacing": "0.0375rem"
    }
  },
  "aux": {
    "xxl": {
      "font-family": "Inter",
      "font-size": "1.375rem",
      "font-style": "normal",
      "font-weight": "400",
      "line-height": "2.2rem",
      "letter-spacing": "0.03125rem"
    },
    "xl": {
      "font-family": "Inter",
      "font-size": "1.25rem",
      "font-style": "normal",
      "font-weight": "400",
      "line-height": "2rem",
      "letter-spacing": "0.03125rem"
    },
    "l": {
      "font-family": "Inter",
      "font-size": "1.1875rem",
      "font-style": "normal",
      "font-weight": "400",
      "line-height": "2.375rem",
      "letter-spacing": "0.05rem"
    },
    "m": {
      "font-family": "Inter",
      "font-size": "1.0625rem",
      "font-style": "normal",
      "font-weight": "400",
      "line-height": "2.125rem",
      "letter-spacing": "0.05rem"
    },
    "s": {
      "font-family": "Inter",
      "font-size": "0.9375rem",
      "font-style": "normal",
      "font-weight": "400",
      "line-height": "1.5rem",
      "letter-spacing": "0.025rem"
    },
    "xs": {
      "font-family": "Inter",
      "font-size": "0.8125rem",
      "font-style": "normal",
      "font-weight": "400",
      "line-height": "1.21875rem",
      "letter-spacing": "0.0375rem"
    },
    "xxs": {
      "font-family": "Inter",
      "font-size": "0.6875rem",
      "font-style": "normal",
      "font-weight": "400",
      "line-height": "1.14125rem",
      "letter-spacing": "0.0375rem"
    },
    "xxxs": {
      "font-family": "Inter",
      "font-size": "0.5625rem",
      "font-style": "normal",
      "font-weight": "400",
      "line-height": "1.0125rem",
      "letter-spacing": "0.0375rem"
    }
  }
};
const spacings = {
  "2": "0.125rem",
  "4": "0.25rem",
  "8": "0.5rem",
  "12": "0.75rem",
  "16": "1rem",
  "24": "1.5rem",
  "32": "2rem",
  "40": "2.5rem",
  "48": "3rem",
  "56": "3.5rem",
  "64": "4rem",
  "72": "4.5rem",
  "80": "5rem",
  "88": "5.5rem",
  "96": "6rem",
  "160": "10rem"
};
const shadows = {
  "xxs": "0px 0px 2px 1px rgba(48, 48, 48, 0.03)",
  "xs": "0px 1px 3px 0px rgba(48, 48, 48, 0.05)",
  "s": "0px 2px 10px 0px rgba(48, 48, 48, 0.06), 0px 1px 6px 0px rgba(48, 48, 48, 0.04)",
  "m": "0px 6px 10px -1px rgba(48, 48, 48, 0.06), 0px 2px 6px -1px rgba(48, 48, 48, 0.06)",
  "l": "0px 10px 15px -3px rgba(48, 48, 48, 0.12), 0px 4px 6px -2px rgba(48, 48, 48, 0.05)",
  "modal": "0px 5px 15px -3px rgba(48, 48, 48, 0.15), 0px 0px 10px -2px rgba(48, 48, 48, 0.06)",
  "m-yellow": "0px 6px 10px -1px rgba(255, 187, 77, 0.06), 0px 2px 6px -1px rgba(255, 187, 77, 0.06)",
  "m-yellow-dark": "0px 6px 10px -1px rgba(255, 157, 0, 0.06), 0px 2px 6px -1px rgba(255, 157, 0, 0.06)"
};
const radiuses = {
  "xxs": "2px",
  "xs": "4px",
  "s": "8px",
  "m": "16px",
  "l": "24px",
  "xl": "32px",
  "max": "999px"
};
const grid = {
  "grid-default-margin": {
    "xs": "24px",
    "sm": "48px",
    "md": "48px",
    "lg": "48px",
    "xl": "72px",
    "xxl": "72px"
  },
  "grid-default-gutter": {
    "xs": "24px",
    "sm": "24px",
    "md": "24px",
    "lg": "24px",
    "xl": "48px",
    "xxl": "48px"
  },
  "grid-max-width": {
    "xs": "100vw",
    "sm": "100vw",
    "md": "100vw",
    "lg": "100vw",
    "xl": "100vw",
    "xxl": "1440px"
  }
};
const fontWeights = {
  "heading": [400],
  "body": [400, 500, 700],
  "aux": [400, 600]
};
const elevations = {
  "base": 0,
  "flat": 1,
  "raised": 2,
  "overlay": 8,
  "sticky-nav": 40,
  "temporary-nav": 50,
  "modal": 99
};
const colors = {
  "white": "#FFFFFF",
  "base": "#303030",
  "accent": "#F0BC75",
  "neutral01": "#F7F7F7",
  "neutral05": "#F1F1F1",
  "neutral10": "#E8E8E8",
  "neutral15": "#DCDCDC",
  "neutral25": "#BDBDBD",
  "neutral35": "#989898",
  "neutral50": "#7C7C7C",
  "neutral60": "#525252",
  "titanium": "#303030",
  "titanium-dark": "#1D1D1D",
  "yellow01": "#FCF5EA",
  "yellow02": "#FAEAD1",
  "yellow03": "#F0BC75",
  "yellow04": "#C07D20",
  "offer01": "#E1F2EA",
  "offer02": "#C3E5D4",
  "offer03": "#69A289",
  "offer04": "#2B7354",
  "error01": "#FFF4F4",
  "error02": "#FCE4E4",
  "error03": "#F5BDBD",
  "error04": "#D81913",
  "warning01": "#FFF6EC",
  "warning02": "#FFE5CB",
  "warning03": "#FCB278",
  "warning04": "#AF4600",
  "success01": "#EEF7EE",
  "success02": "#CFE6CE",
  "success03": "#7EBA8D",
  "success04": "#007E1E",
  "ocean01": "#EFF8FF",
  "ocean02": "#D9ECF9",
  "ocean03": "#95C5E8",
  "ocean04": "#1F69A3",
  "expedition01": "#F1F6FF",
  "expedition02": "#D3DCEF",
  "expedition03": "#3D60A4",
  "expedition04": "#223E75",
  "vs01": "#FDF1F6",
  "vs02": "#EBCCD9",
  "vs03": "#5B0020"
};
const breakpoints = {
  "xs": "0",
  "sm": "480px",
  "md": "768px",
  "lg": "1024px",
  "xl": "1280px",
  "xxl": "1440px"
};
export { typography, spacings, shadows, radiuses, grid, fontWeights, elevations, colors, breakpoints };